import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./App.css";
import HueniLogo2 from "./image/HueniLogo2.png";
import HueniLogo2Circle from "./image/HueniLogo2Circle.png";
import usericon from "./image/user-icon.png";
import Login from "./Login"; // Import the Login component
import "./normal.css";
import API_URL from "./config"; 

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const savedLogin = sessionStorage.getItem("isLoggedIn");
    return savedLogin === "true";
  });

  const initialChatLog = JSON.parse(localStorage.getItem("chatLog")) || [
    {
      user: "gpt",
      message: `**NOTES:**
      \n1. The suggestions provided by AI serve as guidelines and ideas for troubleshooting. 
      They may not guarantee a 100% effective solution for your specific case, as each client and situation is unique. 
      Please exercise caution and carefully consider potential consequences when implementing AI-recommended solutions.
      \n2. To ensure accurate assistance, please start your question by typing the product name from the following list:
      - M5 - M6 - Microtan - Aquamix - Prodomix - Prododos - Prodotracer - PH Tracer - PersonTracer 
      \nHello. I am Hueni AI, what can I help you with?
      `,
    },
  ];
  const [showDataForm, setShowDataForm] = useState(false);
  const [problem, setProblem] = useState("");
  const [solution, setSolution] = useState("");
  const [input, setInput] = useState("");
  const [models, setModels] = useState([]);
  const [currentModel, setCurrentModel] = useState(() => {
    return (
      localStorage.getItem("currentModel") ||
      "ft:gpt-4o-mini-2024-07-18:hueni-ag:05-03-2025:B7g99z0v"//"ft:gpt-4o-mini-2024-07-18:hueni-ag:model3:AOi0BZBj" // This is orginal (Changed at 05 03 2025)
    );
  });

  const [chatLog, setChatLog] = useState(initialChatLog);
  const [showNewChat, setShowNewChat] = useState(false);

  const chatEndRef = useRef(null); // Reference to the end of the chat

  const handleLoginSuccess = (userId) => {
    setIsLoggedIn(true);
    sessionStorage.setItem("isLoggedIn", "true");
    sessionStorage.setItem("currentUser", userId)
    setCurrentModel("ft:gpt-4o-mini-2024-07-18:hueni-ag:05-03-2025:B7g99z0v"); // setCurrentModel("ft:gpt-4o-mini-2024-07-18:hueni-ag:model3:AOi0BZBj"); // Reset to default model // Oringal changed at 03052025
    //localStorage.setItem("currentModel", "ft:gpt-4o-mini-2024-07-18:hueni-ag:aq:An17dHd8"); // Save default model
    setChatLog(initialChatLog);
  };

  // Handle Logout
  const handleLogoutClick = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("currentUser");
    localStorage.removeItem("chatLog");
    localStorage.removeItem("currentModel");
  };

  const customModelList = [
    {
      displayName: "1 - TROUBLESHOOTING",
      actualId: "ft:gpt-4o-mini-2024-07-18:hueni-ag:05-03-2025:B7g99z0v",// actualId: "ft:gpt-4o-mini-2024-07-18:hueni-ag:model3:AOi0BZBj", // Orginal (Changed at 03 05 2025)
    },
    {
      displayName: "2 - MICROTAN",
      actualId: "ft:gpt-4o-mini-2024-07-18:hueni-ag:09-01-2025:AniIvE4f",
    },
    {
      displayName: "3 - AQUAMIX",
      actualId: "ft:gpt-4o-mini-2024-07-18:hueni-ag:aq:An17dHd8",
    },
    {
      displayName: "4 - PRODOMIX",
      actualId: "ft:gpt-4o-mini-2024-07-18:hueni-ag:pm:ApAtfvst",
    },
    { displayName: "5 - PRODODOS", actualId: "gpt-4o-mini" },
    { displayName: "6 - PRODOTRCER", actualId: "gpt-4o-mini" },
    { displayName: "7 - PHTRACER", actualId: "gpt-4o-mini" },
    { displayName: "8 - PERSONTRACER", actualId: "gpt-4o-mini" },
    { displayName: "9 - MASTER M5/M6", actualId: "gpt-4o-mini" },
    // Add more models here if needed
  ];

  useEffect(() => {
    localStorage.setItem("currentModel", currentModel);
  }, [currentModel]);

  useEffect(() => {
    localStorage.setItem("chatLog", JSON.stringify(chatLog));
  }, [chatLog]);

  useEffect(() => {
    getEngines();
  }, []);

  // Scroll to the bottom of the chat when the chatLog is updated
  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom(); // Call scroll to bottom every time the chat log is updated
  }, [chatLog]);

  const toggleDataForm = () => {
    setShowDataForm(!showDataForm);
    setShowNewChat(false);
  };

  const clearChat = () => {
    const defaultChatLog = [
      {
        user: "gpt",
        message: `**NOTES:**
        \n1. The suggestions provided by AI serve as guidelines and ideas for troubleshooting. 
        They may not guarantee a 100% effective solution for your specific case, as each client and situation is unique. 
        Please exercise caution and carefully consider potential consequences when implementing AI-recommended solutions.
        \n2. To ensure accurate assistance, please start your question by typing the product name from the following list:
        - M5 - M6 - Microtan - Aquamix - Prodomix - Prododos - Prodotracer - PH Tracer - PersonTracer.
        \nHello. I am Hueni AI, what can I help you with?
        `,
      },
    ];
    setChatLog(defaultChatLog);
    localStorage.setItem("chatLog", JSON.stringify(defaultChatLog)); // Update localStorage to reflect the cleared state
  };

  const toggleNewChat = () => {
    setShowNewChat(!showNewChat);
    setShowDataForm(false);
  };

  const handleNewChatClick = () => {
    clearChat(); // Clear chat log and update localStorage
    setShowNewChat(true); // Ensure the "NEW CHAT" UI updates correctly
  };

  async function handleDataSubmit() {
    if (!problem || !solution) {
      alert("Please fill in both fields.");
      return;
    }

    const data = {
      problem,
      solution,
      userId: localStorage.getItem("currentUser") || "anonymous",
    };

    try {
      const response = await fetch(`${API_URL}/data`, { // fetch("http://localhost:3080/data", { // working for only local pc 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert("Data submitted successfully!");
        setProblem("");
        setSolution("");
        setShowDataForm(false);
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error submitting data.");
    }
  }

  function getEngines() {
    fetch(`${API_URL}/models`) //fetch("http://localhost:3080/models") // working on local PC 
      .then((res) => res.json())
      .then((data) => {
        setModels(data.models);
      })
      .catch((error) => console.error("Error fetching models:", error));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    let chatLogNew = [...chatLog, { user: "me", message: input }];
    setInput("");
    setChatLog(chatLogNew);

    const messages = chatLogNew.map((message) => message.message).join("\n");

    const response = await fetch(`${API_URL}/`, {// await fetch("http://localhost:3080/", { // work only on local PC 
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: messages, currentModel }),
    });

    const data = await response.json();
    setChatLog([...chatLogNew, { user: "gpt", message: data.message }]);
  }

  if (!isLoggedIn) {
    return <Login onLogin={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      <aside className="sidemenu">
        <div className="logo">
          <img
            src={HueniLogo2}
            alt="Hueni Logo"
            style={{ width: "100px", height: "auto" }}
          />
        </div>
        <h1>Hueni AI</h1>
        <div className="sidemenu-button" onClick={handleNewChatClick}>
          <span>💬</span> NEW CHAT
        </div>

        <div className="sidemenu-button" onClick={toggleDataForm}>
          <span>📄</span> SUBMIT DATA
        </div>

        <div>
          <h4>📖 PRODUCTS LIST :</h4>
          {/* 2) Use the array in JSX */}
          <div className="models">
            <select
              value={currentModel} // Set the selected value
              onChange={(e) => setCurrentModel(e.target.value)}
            >
              {customModelList.map((modelItem, index) => (
                <option key={index} value={modelItem.actualId}>
                  {modelItem.displayName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <footer className="footer">
          <div className="sidemenu-button" onClick={handleLogoutClick}>
            <span>↪</span> LOG OUT
          </div>
          <p>Hüni AG © 2025</p>
          <p>Last Update: Mar 2025</p>
          <p>Version: 1.3.0</p>
          <p>Developer: KaLong</p>
          <p>Email: klm@hueni.com</p>
        </footer>
      </aside>

      <section className="chatbox">
        <div className="chat-log">
          {chatLog.map((message, index) => (
            <ChatMessage key={index} message={message} />
          ))}
          <div ref={chatEndRef} />{" "}
          {/* Reference to ensure scrolling to the bottom */}
        </div>

        {showDataForm && (
          <div className="data-form-modal">
            <div className="data-form-header">
              <h2>Submit Data</h2>
              <button
                className="close-button"
                onClick={() => setShowDataForm(false)}
              >
                X
              </button>
            </div>
            <div className="data-form-body">
              <div>
                <label>Problem:</label>
                <textarea
                  value={problem}
                  onChange={(e) => setProblem(e.target.value)}
                  rows="4"
                  placeholder="Describe the problem here..."
                />
              </div>
              <div>
                <label>Solution:</label>
                <textarea
                  value={solution}
                  onChange={(e) => setSolution(e.target.value)}
                  rows="4"
                  placeholder="Describe the solution here..."
                />
              </div>
              <div className="send-data-button-container">
                <button onClick={handleDataSubmit} className="send-data-button">
                  Send
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="chat-input-holder">
          <form onSubmit={handleSubmit} className="input-with-button">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="chat-input-textarea"
              placeholder="Type your questions here..."
            />
            <button type="submit" className="send-button">
              <img
                src={HueniLogo2Circle}
                alt="Hueni Logo circle"
                className="circleLogo"
                style={{ width: "30px", height: "auto" }}
              />
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

const ChatMessage = ({ message }) => (
  <div
    className={`chat-message ${message.user === "gpt" ? "chatgpt" : "user"}`}
  >
    <div className="chat-message-center">
      <div className={`avatar ${message.user === "gpt" ? "chatgpt" : "user"}`}>
        {message.user === "gpt" ? (
          <img
            src={HueniLogo2Circle}
            alt="Hueni Logo circle"
            style={{ width: "40px", height: "auto" }}
          />
        ) : (
          <img
            src={usericon}
            alt="user icon"
            style={{ width: "41px", height: "auto" }}
          />
        )}
      </div>
      <div className="message">
        {message.user === "gpt" ? (
          <ReactMarkdown>{message.message}</ReactMarkdown>
        ) : (
          <span>{message.message}</span>
        )}
      </div>
    </div>
  </div>
);

export default App;
